function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Emoji_Like");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "P_St_A",
  transform: "translate(-543.000000, -482.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(409.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Emoji_Like",
  transform: "translate(134.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "skin",
  fill: "#FCEA2B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "9.861264 0.0875448 8.756748 0.3313548 3.024 6.8832288 0.252126 11.8195308 1.007748 16.0811028 5.898312 18.7535628 9.536562 18.7380648 14.844438 18.8166888 15.749748 18.2232288 16.033248 16.7743548 15.749748 16.1756028 17.1045 16.1442288 17.608374 15.5141028 17.923248 14.6322288 17.324874 13.4982288 17.923248 13.2461028 18.647874 12.2383548 18.301248 11.1988548 17.356248 10.7577288 17.797374 9.9386028 17.8605 8.6473548 16.883748 8.0803548 11.907 7.8913548 11.591748 7.6392288 11.268936 7.4135628 7.819686 7.4135628 7.8435 6.7573548 9.323748 3.1346028 9.953874 1.4022288"
})), /*#__PURE__*/React.createElement("g", {
  id: "line",
  transform: "translate(0.378000, 0.000000)",
  stroke: "#000000",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.783208,18.3710268 L5.381208,18.3710268 C2.23587,18.3710268 0.089208,15.8456088 0.089208,12.7010268 C0.0969192,10.886967 0.7693434,9.138717 1.979208,7.7870268",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.55225,7.7870268 L6.893208,7.7870268 L9.539208,0.9830268 C9.845766,0.1952748 8.484588,-0.4533732 7.649208,0.6050268 L1.979208,7.7870268",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.619344,9.1100268 C9.6770646,9.8901432 10.3504716,10.4793696 11.131344,10.4330268 L16.045344,10.4330268 C16.776018,10.5304752 17.447346,10.017189 17.5448322,9.286515 C17.6423184,8.555841 17.1289944,7.884513 16.3983204,7.7870268 C16.2811782,7.7714154 16.162524,7.7714154 16.0453818,7.7870268 L11.1313818,7.7870268 C10.3504716,7.740684 9.6770646,8.3299104 9.619344,9.1100268 Z",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.94329,17.1750348 C10.0010106,17.9551512 10.6744176,18.5443776 11.45529,18.4980348 L14.10129,18.4980348 C14.831964,18.5954832 15.503292,18.082197 15.6007782,17.351523 C15.6982644,16.620849 15.1849404,15.949521 14.4542664,15.8520348 C14.3371242,15.8364234 14.21847,15.8364234 14.1013278,15.8520348 L11.4553278,15.8520348 C10.6744176,15.805692 10.0010106,16.3949184 9.94329,17.1750348 Z",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.027208,11.8830348 C8.0849286,12.6631512 8.7583356,13.2523776 9.539208,13.2060348 L16.721208,13.2060348 C17.451882,13.3034832 18.12321,12.790197 18.2206962,12.059523 C18.3181824,11.328849 17.8048584,10.657521 17.0741844,10.5600348 C16.9570422,10.5444234 16.838388,10.5444234 16.7212458,10.5600348 L9.5392458,10.5600348 C8.7583356,10.513692 8.0849286,11.1029184 8.027208,11.8830348 Z",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.783208,14.5290348 C8.8409286,15.3091512 9.5143356,15.8983776 10.295208,15.8520348 L15.965208,15.8520348 C16.695882,15.9494832 17.36721,15.436197 17.4646962,14.705523 C17.5621824,13.974849 17.0488584,13.303521 16.3181844,13.2060348 C16.2010422,13.1904234 16.082388,13.1904234 15.9652458,13.2060348 L10.2952458,13.2060348 C9.5143356,13.159692 8.8409286,13.7489184 8.783208,14.5290348 Z",
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.807408,9.5492628 C0.36288,10.4757786 0.1174446,11.4851898 0.08694,12.5124048 C0.08694,15.7480848 1.83519,18.3714048 5.80419,18.3714048",
  id: "Path"
}))))));

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.6592e606.svg";
export { ForwardRef as ReactComponent };